<template>
  <div class="bg-list-wrapper" ref="wrapper">
    <el-carousel trigger="click" :height="height" arrow="never" :indicator-position="list.length <= 1?'none':''">
      <el-carousel-item v-for="item in list" :key="item">
        <div class="bg-item" :style="{backgroundImage:'url('+getRealUrl(item)+')'}"></div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { imgBaseUrl } from '@/utils/common'
export default {
  props:{
    list:{
      type:Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      height:'0',
    }
  },
  mounted() {
    this.getHeight()
    window.addEventListener('resize', this.getHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods:{
    getRealUrl(url){
      if(url) {
        let str = "/image/"
        if (url.indexOf(str) == 0) {
          return url
        } else {
          return imgBaseUrl + url
        }
      }
    },
    getHeight() {
      this.height = this.$refs.wrapper.offsetHeight + 'px'
    }
  }
}
</script>

<style lang="scss">
.bg-list-wrapper {
  .el-carousel {
    .el-carousel__indicators {
      bottom: auto!important;
      right: 10px!important;
      top: 50%!important;
      left: auto!important;
      transform: translateY(-50%)!important;
      width: 4px!important;
      .el-carousel__button{
        background-color: #ffffff!important;
        width: 2px!important;
        height: 30px!important;
        border-radius: 0!important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.bg-list-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .el-carousel {
    width: 100%;
    .bg-item {
      width: 100%;
      height: 100%;
      background-size: cover;
    }
  }
}
</style>